import Link from "next/link";
import styles from "./footer.module.scss";
import { ROUTES } from "../../../services/router-services";
import Aparat from "../../../../shared-assets/Svg/Aparat.svg";
import Telegram from "../../../../shared-assets/Svg/Telegram.svg";
import Sorosh from "../../../../shared-assets/Svg/Sorosh.svg";
import Instagram from "../../../../shared-assets/Svg/Instagram.svg";
import WhatsApp from "../../../../shared-assets/Svg/WhatsApp.svg";
import ArrowUp from "../../../../shared-assets/Svg/Down.svg";
import { useContext, useState } from "react";
import { trackEvent } from "../../../services/ga-services";
import AppContext from "../../../services/app-context-services";
import { Mask } from "../mask/mask";
import { API } from "../../../services/api-services";

type FooterProps = {
  isNavbar?: Boolean;
};

const FooterApp = ({ isNavbar }: FooterProps) => {
  const { isIntlUser } = useContext(AppContext);
  const [showOtherLinks, setShowOtherLinks] = useState(false);

  const handleClose = () => {
    setShowOtherLinks(false);
  };
  return (
    <>
      {!isIntlUser && (
        <footer
          className={styles.footer}
          style={{
            overflow: !showOtherLinks ? "hidden" : "visible",
            bottom: isNavbar ? "70px" : "0"
          }}
        >
          <div className={styles.rightSide}>
            <div onClick={() => trackEvent("Footer", "اپلیکیشن‌ها")}>
              <Link href={ROUTES.download}>دانلود اپلیکیشن</Link>
            </div>
            <div onClick={() => trackEvent("Footer", "نسخهٔ تلویزیون هوشمند")}>
              <Link href={API.tv_site}> نسخهٔ تلویزیون هوشمند</Link>
            </div>
            <div onClick={() => trackEvent("Footer", "قوانین و مقررات")}>
              <Link href={ROUTES.terms}>قوانین و مقررات</Link>
            </div>
            <div onClick={() => trackEvent("Footer", "تماس با ما")}>
              <Link href={ROUTES.contactUs}>تماس با ما</Link>
            </div>
            <div onClick={() => trackEvent("Footer", "درباره ما")}>
              <Link href={ROUTES.aboutUs}>درباره ما</Link>
            </div>
            <div onClick={() => trackEvent("Footer", "جزئیات اینترنت")}>
              <Link href={ROUTES.freeTraffic}>جزئیات اینترنت</Link>
            </div>
            {/* <div onClick={() => trackEvent("Footer", "تبلیغات در دیجیتون")}>
              <Link href={ROUTES.advertise}>تبلیغات در دیجیتون</Link>
            </div> */}
            <div onClick={() => trackEvent("Footer", "دیجیتون مگ")}>
              <Link href={ROUTES.blog}>دیجیتون مگ </Link>
            </div>
            <div onClick={() => trackEvent("Footer", "دیجیتون فان")}>
              <a href={API.digitoon_fun}>دیجیتون فان</a>
            </div>
          </div>

          <div className={styles.leftSide}>
            <div onClick={() => trackEvent("Footer", "اینستاگرام")}>
              <Link href={"https://www.instagram.com/digitoon.ir/"}>
                <span>
                  <Instagram width={"100%"} height={"100%"} />
                </span>
              </Link>
            </div>
            <div onClick={() => trackEvent("Footer", "واتساپ")}>
              <Link href={"https://wa.me/+989387363982"}>
                <span>
                  <WhatsApp width={"100%"} height={"100%"} />
                </span>
              </Link>
            </div>
            <div onClick={() => trackEvent("Footer", "آپارات")}>
              <Link href={"https://www.aparat.com/digitoon"}>
                <span>
                  <Aparat width={"100%"} height={"100%"} />
                </span>
              </Link>
            </div>
            <div onClick={() => trackEvent("Footer", "سروش")}>
              <Link href={"https://sapp.ir/digitoon"}>
                <span>
                  <Sorosh width={"100%"} height={"100%"} />
                </span>
              </Link>
            </div>

            <div onClick={() => trackEvent("Footer", "تلگرام")}>
              <Link href={"https://t.me/ReezeMeeze"}>
                <span>
                  <Telegram width={"100%"} height={"100%"} />
                </span>
              </Link>
            </div>
          </div>

          <div
            className={styles.otherApps}
            onClick={() => setShowOtherLinks(!showOtherLinks)}
          >
            سایر لینک ها
            <span
              style={{
                transform: showOtherLinks ? "rotate(180deg)" : "rotate(0deg)"
              }}
            >
              <ArrowUp width={"100%"} height={"100%"} />
            </span>
          </div>
          {
            <div
              className={`${styles.dropDownWrapper} ${
                !showOtherLinks && styles.dropDownWrapperNone
              }`}
              // style={{ top: !showOtherLinks ? "200px" : "-360px" }}
            >
              <div className={styles.othersLinks}>
                <div onClick={() => trackEvent("Footer", "قوانین و مقررات")}>
                  <Link href={ROUTES.terms}>قوانین و مقررات</Link>
                </div>
                <div onClick={() => trackEvent("Footer", "تماس با ما")}>
                  <Link href={ROUTES.contactUs}>تماس با ما</Link>
                </div>
                <div onClick={() => trackEvent("Footer", "درباره ما")}>
                  <Link href={ROUTES.aboutUs}>درباره ما</Link>
                </div>
                <div
                  onClick={() => trackEvent("Footer", "نسخهٔ تلویزیون هوشمند")}
                >
                  <Link href={API.tv_site}> نسخهٔ تلویزیون هوشمند</Link>
                </div>
                <div onClick={() => trackEvent("Footer", "جزئیات اینترنت")}>
                  <Link href={ROUTES.freeTraffic}>جزئیات اینترنت</Link>
                </div>
                {/* <div onClick={() => trackEvent("Footer", "تبلیغات در دیجیتون")}>
                  <Link href={ROUTES.advertise}>تبلیغات در دیجیتون</Link>
                </div> */}
                <div onClick={() => trackEvent("Footer", "دیجیتون مگ")}>
                  <Link href={ROUTES.blog}>دیجیتون مگ </Link>
                </div>
                <div onClick={() => trackEvent("Footer", "دیجیتون فان")}>
                  <a href={API.digitoon_fun}>دیجیتون فان</a>
                </div>
              </div>
              <div className={styles.otherSocialMedia}>
                <div onClick={() => trackEvent("Footer", "اینستاگرام")}>
                  <Link href={"https://www.instagram.com/digitoon.ir/"}>
                    <span>
                      <Instagram width={"100%"} height={"100%"} />
                    </span>
                  </Link>
                </div>
                <div onClick={() => trackEvent("Footer", "واتساپ")}>
                  <Link href={"https://wa.me/+989387363982"}>
                    <span>
                      <WhatsApp width={"100%"} height={"100%"} />
                    </span>
                  </Link>
                </div>
                <div onClick={() => trackEvent("Footer", "آپارات")}>
                  <Link href={"https://www.aparat.com/digitoon"}>
                    <span>
                      <Aparat width={"100%"} height={"100%"} />
                    </span>
                  </Link>
                </div>
                <div onClick={() => trackEvent("Footer", "سروش")}>
                  <Link href={"https://sapp.ir/digitoon"}>
                    <span>
                      <Sorosh width={"100%"} height={"100%"} />
                    </span>
                  </Link>
                </div>

                <div onClick={() => trackEvent("Footer", "تلگرام")}>
                  <Link href={"https://t.me/ReezeMeeze"}>
                    <span>
                      <Telegram width={"100%"} height={"100%"} />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          }
        </footer>
      )}

      {/* {showOtherLinks &&
        createPortal(
          <div
            className={`${styles.backdrop} animate__animated ${showOtherLinks ? 'animate__fadeIn' : 'animate__fadeOut'}`}
            onClick={() => setShowOtherLinks(false)}
          ></div>,
          document.body
        )} */}
      {showOtherLinks && (
        <Mask handleCloser={handleClose} showMask={showOtherLinks} zIndex={1} />
      )}
    </>
  );
};

export default FooterApp;
